// ReviewPrompt Modal - App Store Bewertung
const ReviewPrompt = ({ 
  show, 
  t, 
  onReview, 
  onLater, 
  onNever 
}) => {
  if (!show) return null;
  
  return (
    <div className="notification-prompt-overlay" data-testid="review-prompt-overlay">
      <div className="notification-prompt review-prompt">
        <div className="review-stars">⭐⭐⭐⭐⭐</div>
        <h3>{t.reviewTitle}</h3>
        <p className="review-subtext">{t.reviewSubtext}</p>
        <div className="prompt-buttons">
          <button 
            className="prompt-btn primary" 
            onClick={onReview} 
            data-testid="review-accept"
          >
            {t.reviewButton}
          </button>
          <button 
            className="prompt-btn secondary" 
            onClick={onLater} 
            data-testid="review-later"
          >
            {t.reviewLater}
          </button>
          <button 
            className="prompt-btn tertiary" 
            onClick={onNever} 
            data-testid="review-never"
          >
            {t.reviewNever}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewPrompt;
